import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { PaperClipIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import StepTracker from "./StepTracker";
import PolicyOwnerReview from "./Components/PolicyOwnerReview";

const ProgramActivation = () => {
  const steps = ["Search", "Policy Owner", "Add Driver", "Review", "Submitted"];
  const [isOwner, setIsOwner] = useState(null); // null | "yes" | "no"

  const [formData, setFormData] = useState({
    cpr: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });
  const isFormEmpty =
    !formData.cpr ||
    !formData.firstName ||
    !formData.lastName ||
    !formData.email ||
    !formData.phone ||
    !isOwner;

  const [Policy, setPolicy] = useState("");
  const [PolicyStatus, setPolicyStatus] = useState("");
  const [ownerCPR, setOwnerCPR] = useState("");
  const [ownerFname, setOwnerFname] = useState("");
  const [ownerLname, setOwnerLname] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [plateNo, setPlateNo] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const [step, setStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const GetPolicyDetails = async () => {
    const url = process.env.REACT_APP_PAYMENT_API + "Policy/GetPolicyDetails";
    const data = {
      Policy: Policy, // Use the search string here
    };

    try {
      setIsLoading(true);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        toast.error(errorDetails.message, {
          style: {
            background: "#ffcccc",
            color: "black",
            fontWeight: "bold",
          },
        });
        throw new Error("Failed to login");
      }

      const result = await response.json();
      return result;
      //navigate('/requests');
    } catch (error) {
      setIsLoading(false);
      toast.error("Something went wrong", {
        style: {
          background: "#ffcccc",
          color: "black",
          fontWeight: "bold",
        },
      });
      console.error("Error", error);
    }
  };

const getToken = async () => {
  const url = process.env.REACT_APP_WEB_API + "token";

  const body = "username=accountsdashboard&password=Acc@dash123"; // Replace with actual values

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: body,
    });

    if (!response.ok) {
      throw new Error("Failed to fetch token");
    }

    const result = await response.json();
    return result.access_token; // Adjust key name if needed
  } catch (error) {
    console.error("Token Error:", error);
    return null;
  }
};

const GetPolicyDetailsFromWebAPI = async () => {
  const url = process.env.REACT_APP_WEB_API + "policy/view";
  const data = {
    PolicyNumber: Policy,
    Channel: ""
  };
    setIsLoading(true);
    
    var token = await getToken();
    //var token = tokenDetails.access_token;
  try {
    
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, // Add Bearer token here
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorDetails = await response.json();
      toast.error(errorDetails.message, {
        style: {
          background: "#ffcccc",
          color: "black",
          fontWeight: "bold",
        },
      });
      throw new Error("Failed to retrieve policy details");
    }

    const result = await response.json();
    setIsLoading(false);
    return result;
  } catch (error) {
    setIsLoading(false);
    toast.error("Something went wrong", {
      style: {
        background: "#ffcccc",
        color: "black",
        fontWeight: "bold",
      },
    });
    console.error("Error", error);
  }
};


  const GoBack = () => {
    setIsLoading(false);
    if (step === 0) {
      setPolicyStatus("");
      setStartDate("");
      setEndDate("");
      setPlateNo("");
      setEmail("");
      setPhone("");
    }

    setStep((prev) => Math.max(prev - 1, 0));
  };

  const GoNext = () => {
    setStep((prev) => Math.min(prev + 1, steps.length - 1));
    setIsLoading(false);
    console.log(step);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    var policyDetails = await GetPolicyDetailsFromWebAPI();

    if (policyDetails != undefined) {
      setPolicyStatus(policyDetails?.PolicyHeader?.StatusCode);
      setStartDate(policyDetails?.PolicyHeader?.FromDateStr);
      setEndDate(policyDetails?.PolicyHeader?.ToDateStr);
      setPlateNo(policyDetails?.PolicyHeader?.RegistrationNumber);
      setEmail(policyDetails?.PolicyHeader?.Party?.Email);
      setPhone(policyDetails?.PolicyHeader?.Party?.PhoneNumber);
      setOwnerCPR(policyDetails?.PolicyHeader?.Party?.CPR);
      setOwnerFname(policyDetails?.PolicyHeader?.Party?.FirstName);
      setOwnerLname(policyDetails?.PolicyHeader?.Party?.LastName);

      setStep(1);
    }
  };
  useEffect(() => {
    console.log("Current step:", step);
  });
  return (
    <div className=" max-w-md p-4">
      {/* Forms */}
      <StepTracker currentStep={step} steps={steps} />

      <form
        onSubmit={handleSubmit}
        className={`space-y-4 ${step === 0 ? "" : "hidden"} }`}
      >
        <label className="block text-sm font-medium text-gray-700">
          Policy Number
        </label>
        <input
          disabled={isLoading}
          type="text"
          value={Policy}
          onChange={(e) => setPolicy(e.target.value)}
          className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 ${
            isLoading ? "bg-gray-200 cursor-not-allowed" : "focus:ring-blue-500"
          }`}
          placeholder="Enter policy number"
          required
        />
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 flex justify-center items-center"
        >
          {isLoading ? (
            <div className="w-5 h-5 border-4 border-t-transparent border-white rounded-full animate-spin"></div>
          ) : (
            "Search"
          )}
        </button>
      </form>
      <div>
        <div
          className={`bg-white p-4 border rounded-md ${
            step === 1 ? "" : "hidden"
          } }`}
        >
          <div className="px-4 sm:px-0">
            <h3 className="text-base/7 font-semibold text-gray-900">
              Policy Owner Information
            </h3>
          </div>
          <div className="mt-6 border-t border-gray-100">
            <dl className="divide-y divide-gray-100">
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900">
                  First Name
                </dt>
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {ownerFname}
                </dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900">
                  Last Name
                </dt>
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {ownerLname}
                </dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900">
                  Policy Number
                </dt>
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {Policy}
                </dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900">Plan</dt>
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {Policy.split("/")[4] === "8004"
                    ? "Third Party"
                    : "Comprehensive"}
                </dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900">
                  Start Date
                </dt>
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {startDate}
                </dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900">
                  Start Date
                </dt>
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {endDate}
                </dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900">
                  Email address
                </dt>
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {email ?? "Need to add email in core before activating"}
                </dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900">
                  Phone Number
                </dt>
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {phone ??
                    "Need to add phone number in core before activating"}
                </dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900">
                  Policy Status
                </dt>
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {PolicyStatus == "05" ? "Active" : "Not Active"}
                </dd>
              </div>
            </dl>
          </div>

          <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <button
              onClick={GoBack}
              type="button"
              className="text-sm/6 font-semibold text-gray-900"
            >
              Back
            </button>
            <button
              onClick={GoNext}
              type="submit"
              className={`${
                email == null || phone == null ? "hidden" : ""
              } rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
            >
              Next
            </button>
          </div>
        </div>

        <div className={`${step === 2 ? "" : "hidden"}`}>
          <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
            <div className="px-4 py-6 sm:p-8">
              <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                <div className="sm:col-span-4">
                  <label className="block text-sm/6 font-medium text-gray-900 mb-2">
                    Is the driver the policy owner?
                  </label>
                  <div className="flex items-center gap-6">
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="isOwner"
                        value="yes"
                        checked={isOwner === "yes"}
                        onChange={() => {
                          setIsOwner("yes");
                          setFormData({
                            cpr: ownerCPR, // or fetch real data
                            firstName: ownerFname,
                            lastName: ownerLname,
                            email: email,
                            phone: phone,
                          });
                        }}
                        className="text-indigo-600 focus:ring-indigo-500 border-gray-300"
                      />
                      <span className="ml-2 text-sm text-gray-700">Yes</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="isOwner"
                        value="no"
                        checked={isOwner === "no"}
                        onChange={() => {
                          setIsOwner("no");
                          setFormData({
                            cpr: "", // or fetch real data
                            firstName: "",
                            lastName: "",
                            email: "",
                            phone: "",
                          });
                        }}
                        className="text-indigo-600 focus:ring-indigo-500 border-gray-300"
                      />
                      <span className="ml-2 text-sm text-gray-700">No</span>
                    </label>
                  </div>
                </div>

                <div className="sm:col-span-4">
                  <label
                    htmlFor="email"
                    className="block text-sm/6 font-medium text-gray-900"
                  >
                    CPR
                  </label>
                  <div className="mt-2">
                    <input
                      id="cpr"
                      name="cpr"
                      type="number"
                      autoComplete="email"
                      value={formData.cpr}
                      onChange={(e) =>
                        setFormData({ ...formData, cpr: e.target.value })
                      }
                      disabled={isOwner === "yes"}
                      className={`block w-full rounded-md px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 sm:text-sm/6 ${
                        isOwner === "yes"
                          ? "bg-gray-100 cursor-not-allowed"
                          : "bg-white"
                      }`}
                    />
                  </div>
                </div>
                <div className="sm:col-span-3">
                  <label
                    htmlFor="first-name"
                    className="block text-sm/6 font-medium text-gray-900"
                  >
                    First name
                  </label>
                  <div className="mt-2">
                    <input
                      id="first-name"
                      name="first-name"
                      type="text"
                      value={formData.firstName}
                      onChange={(e) =>
                        setFormData({ ...formData, firstName: e.target.value })
                      }
                      autoComplete="given-name"
                      disabled={isOwner === "yes"}
                      className={`block w-full rounded-md px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 sm:text-sm/6 ${
                        isOwner === "yes"
                          ? "bg-gray-100 cursor-not-allowed"
                          : "bg-white"
                      }`}
                    />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label
                    htmlFor="last-name"
                    className="block text-sm/6 font-medium text-gray-900"
                  >
                    Last name
                  </label>
                  <div className="mt-2">
                    <input
                      id="last-name"
                      name="last-name"
                      type="text"
                      autoComplete="family-name"
                      value={formData.lastName}
                      onChange={(e) =>
                        setFormData({ ...formData, lastName: e.target.value })
                      }
                      disabled={isOwner === "yes"}
                      className={`block w-full rounded-md px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 sm:text-sm/6 ${
                        isOwner === "yes"
                          ? "bg-gray-100 cursor-not-allowed"
                          : "bg-white"
                      }`}
                    />
                  </div>
                </div>

                <div className="sm:col-span-4">
                  <label
                    htmlFor="email"
                    className="block text-sm/6 font-medium text-gray-900"
                  >
                    Email address
                  </label>
                  <div className="mt-2">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                      disabled={isOwner === "yes"}
                      className={`block w-full rounded-md px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 sm:text-sm/6 ${
                        isOwner === "yes"
                          ? "bg-gray-100 cursor-not-allowed"
                          : "bg-white"
                      }`}
                    />
                  </div>
                </div>

                <div className="sm:col-span-4">
                  <label
                    htmlFor="email"
                    className="block text-sm/6 font-medium text-gray-900"
                  >
                    Phone Number
                  </label>
                  <div className="mt-2">
                    <input
                      id="phone"
                      name="phone"
                      type="number"
                      value={formData.phone}
                      onChange={(e) =>
                        setFormData({ ...formData, phone: e.target.value })
                      }
                      disabled={isOwner === "yes"}
                      className={`block w-full rounded-md px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 sm:text-sm/6 ${
                        isOwner === "yes"
                          ? "bg-gray-100 cursor-not-allowed"
                          : "bg-white"
                      }`}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
              <button
                onClick={GoBack}
                type="button"
                className="text-sm/6 font-semibold text-gray-900"
              >
                Back
              </button>
              <button
                onClick={GoNext}
                type="button"
                disabled={isFormEmpty}
                className={`rounded-md px-3 py-2 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
          ${
            isFormEmpty
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-indigo-600 text-white hover:bg-indigo-500 focus-visible:outline-indigo-600"
          }`}
              >
                Next
              </button>
            </div>
          </form>
        </div>
        {step === 3 && (
          <PolicyOwnerReview
            ownerFname={formData.firstName}
            ownerLname={formData.lastName}
            Policy={Policy}
            startDate={startDate}
            endDate={endDate}
            email={formData.email}
            phone={formData.phone}
            PolicyStatus={PolicyStatus}
            Driver={formData}
            GoBack={GoBack}
            GoNext={GoNext}
            toast={toast}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
          />
        )}

        {step === 4 && (
          <div>
            <div className="bg-white shadow sm:rounded-lg">
              <div className="px-4 py-5 sm:p-6">
                <h3 className="text-base font-semibold text-gray-900">Done</h3>
                <div className="mt-2 max-w-xl text-sm text-gray-500">
                  <p>
                    Plan Created for{" "}
                    {formData.firstName + " " + formData.lastName}
                  </p>
                </div>
                <div className="mt-5">
                  <button
                    type="button"
                    onClick={() => window.location.reload()}
                    className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
                  >
                    Finish
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <ToastContainer />
    </div>
  );
};

export default ProgramActivation;
